import { GET } from "../utils/constants";
import { fetchData } from "../utils/dataProvider";

export const getAuditsList = (query?: string) => {
  return fetchData({
    url: `/marketplaces_merchants/getCredentialAudits${query}`,
    method: GET,
  });
};
